<template>
	<div class="ReAddBalance">
		<h4><i class="tim-icons icon-money-coins text-success mr-3"></i>Мой баланс: {{ $GVO.number_format($GVO.iTechBalance,0,'.',' ') }} ₽</h4>
		<label class="col-form-label col-md-12 px-0"> <span>Сумма, ₽</span></label>
		<div class="form-group col-md-12 px-0">
			<ReInputAmount placeholder="денежки" v-model="bufferValue" />
		</div>
		<base-button class="form-group col-md-12" type="success" simple @click="INS_PAYMENT()">Пополнить баланс</base-button>
		<!-- <p class="description">Для пополнения личного счета введите сумму и нажмите "Пополнить баланс". Для ввода реквизитов Вашей карты Вы будете 
			перенаправлены на платежный шлюз ПАО СБЕРБАНК. Соединение с платежным шлюзом и передача информации осуществляется в защищенном режиме с 
			использованием протокола шифрования SSL. В случае, если Ваш банк поддерживает технологию безопасного проведения интернет-платежей VerifiedBy Visa, 
			MasterCard SecureCode, MIR Accept, J-Secure для проведения платежа также может потребоваться ввод специального пароля. Настоящий сайт 
			поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО СБЕРБАНК. Введенная информация 
			не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам 
			осуществляется в строгом соответствии с требованиями платежных систем МИР, Visa Int., MasterCard Europe Sprl, JCB.</p> -->

		<p class="description">
			Для пополнения личного счета введите сумму и нажмите "Пополнить баланс".
		</p>	
		<p class="description">
			Реквизиты: <br>
			Наименование (Beneficiary Name): ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ "АЛЕКСАНДР-НЕДВИЖИМОСТЬ" <br>
			ИНН (INN): 7842216236 <br>
			КПП (KPP): 784201001 <br>
			Номер счёта (Account Number): 40702810232130014423 <br>
			Банк (Bank): ФИЛИАЛ "САНКТ-ПЕТЕРБУРГСКИЙ" АО "АЛЬФА-БАНК" <br>
			Кор. счёт (Correspondent Account): 30101810600000000786 <br>
			БИК (BIC): 044030786
		</p>	
		
		<h6 class="mt-2">В случае возникновения проблем с проведением оплаты, обращайтесь в службу поддержки.</h6>
		<!-- <base-button class="form-group col-md-12" type="warning" simple @click="INS_PAYBACK()">Подкинь сотку на 2дня</base-button> --> 
		<!-- кнопка временно скрыта, откроем, когда потребуется-->
		<ReAddBalanceHistory v-on:refrashrentcharge="refrashrentcharge"/>
		
	</div>
</template>

<script>

import ReInputAmount from 'src/our_components/ReInputAmount.vue';
import swal from 'sweetalert2';
import ReAddBalanceHistory from './ReAddBalanceHistory.vue';
	export default {
		name: 'ReAddBalance',
		components: {
			ReInputAmount,
			ReAddBalanceHistory,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: [String,Number],
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
		},
		computed: {

		},
		methods: {
			INS_PAYMENT(){
				this.$GVO.ApiCall('billing.CREATE_PAYMENT_SBER',{'data':{'amount':this.$GVO.str_replace(' ','',this.bufferValue)}})
				.then((objApi) => {
					if(objApi.success){
						location.href = objApi.data.formUrl;
					}else if (objApi.msg){
							swal({
								title: 'Ошибка счета',
								buttonsStyling: false,
								confirmButtonClass: 'btn btn-danger btn-fill',
								text: `${objApi.msg}`,
								
							});

							// this.$GVO.showAlert('Документация',`<pre>${objApi.data.replace(/</g,'&lt;')}</pre>`);
							// alert(objApi.msg);

						}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			},
			INS_PAYBACK(){
				this.$GVO.ApiCall('billing.INS_PAYBACK',{'iData':{'amount':100}})
				.then((objApi) => {
					if(objApi.success){
						//location.reload();
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			},
			refrashrentcharge(data){
				this.$emit("refrashrentcharge", data);
			}
			
		},
		mounted() {
			
		}
	}
</script>
<style scoped>
.ReAddBalance .description {font-size: 14px;}

</style>
